export const DEFAULT_TITLE = 'Belatra'
export const DEFAULT_DESCRIPTION =
  "An award-winning casino solutions provider, we're here to transform your online and offline gaming experience with our exceptional slots. Indulge in fun, fair, and secure gaming with 80+ reeled games. Play on any device, using fiat or crypto."
export const SITE_NAME = 'belatragames.com'
export const COMPANY_NAME = 'Belatra'
export enum SLUGS {
  SIGMA = 'sigma',
  SAGSE = 'sagse',
  PGS = 'pgs',
  CGS = 'cgs',
  SBC_2024 = 'sbc-summit-lisbon-2024',
  SBC_2026 = 'sbc-summit-lisbon-2026',
  SIGMA_2024 = 'sigma-europe-2024',
  SIGMA_2025 = 'sigma-roma-2025',
  RIO_2025 = 'summit-rio-2025',
  SAGSE_2025 = 'sagse-latam-2025',
  SIGMA_AMERICAS2025 = 'sigma-americas-2025',
  SBC_2025 = 'sbc-summit-lisbon-2025',
  IGAMING_HOBBIES_SURVEY = 'igaming-hobbies-survey',
  ICE_BARCELONA_2026 = 'ice-barcelona-2026',
  SIGMA_SAO_PAULO_2026 = 'sigma-sao-paulo-2026',
}
export const AUTHOR = 'Dev Family Team'
